<template>
  <div>
    <!-- 面包屑 -->
    <breadcrumbs></breadcrumbs>
    <!-- 表单查询 -->
    <div class="bg-white pdt-10 pdb-10">
      <el-form ref="form" :model="form" label-width="150px" :inline="true">
        <el-form-item label="运营商">
          <el-select clearable v-model="form.operator" placeholder="请选择">
            <el-option label="移动" value="移动"></el-option>
            <el-option label="联通" value="联通"></el-option>
            <el-option label="电信" value="电信"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="SIM卡号">
          <el-input
            v-model="form.simNum"
            placeholder="请输入SIM卡号"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="网络状态">
          <el-select
            clearable
            v-model="form.networkStatus"
            placeholder="请选择"
          >
            <el-option label="已开启" value="1"></el-option>
            <el-option label="已关闭" value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="设备编号">
          <el-input
            v-model="form.equipmentNum"
            placeholder="请输入设备编号"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="卡状态">
          <el-select clearable v-model="form.status" placeholder="请选择">
            <el-option label="停机" value="停机"></el-option>
            <el-option label="预销号" value="预销号"></el-option>
            <el-option label="销号" value="销号"></el-option>
            <el-option label="待激活" value="待激活"></el-option>
            <el-option label="未知" value="未知"></el-option>
            <el-option label="正常" value="正常"></el-option>
            <el-option label="测试期正常" value="测试期正常"></el-option>
            <el-option label="测试期停机" value="测试期停机"></el-option>
            <el-option label="停机保号" value="停机保号"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="到期时间">
          <el-date-picker
            v-model="form.startTime"
            format="yyyy-MM-dd"
            type="date"
            placeholder="开始日期"
            value-format="yyyy-MM-dd"
          >
          </el-date-picker>
          至
          <el-date-picker
            v-model="form.endTime"
            :picker-options="pickerOptionsEnd"
            format="yyyy-MM-dd"
            type="date"
            placeholder="结束日期"
            value-format="yyyy-MM-dd"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="getList()">查询</el-button>
          <el-button
            @click="
              form = { startTime: '', endTime: '' };
              getList();
            "
            >重置</el-button
          >
        </el-form-item>
      </el-form>
    </div>
    <!-- 按钮 -->
    <btns class="mgb-20" @exec="exec"></btns>
    <!-- 表格 -->
    <el-table
      :data="tableData"
      border
      stripe
      style="width: 100%"
      @selection-change="handleSelectionChange"
    >
      <el-table-column type="selection" width="55"> </el-table-column>
      <el-table-column
        type="index"
        :index="indexMethod"
        label="序号"
        width="50"
        fixed="left"
      >
      </el-table-column>
      <el-table-column prop="iccid" label="SIM卡号"> </el-table-column>
      <el-table-column prop="carrier" label="运营商"> </el-table-column>
      <el-table-column prop="equipmentNum" label="设备编号"> </el-table-column>
      <el-table-column prop="status" label="卡状态"> </el-table-column>
      <el-table-column prop="address" label="网络状态">
        <template slot-scope="scope">
          <span
            v-text="
              scope.row.netStatus == 1
                ? '已开启'
                : scope.row.netStatus == 2
                ? '已关闭'
                : '- -'
            "
          ></span>
        </template>
      </el-table-column>
      <el-table-column prop="flow" label="已用流量"> </el-table-column>
      <el-table-column prop="address" label="剩余流量">
        <template slot-scope="scope">
          <span>- -</span>
        </template>
      </el-table-column>
      <el-table-column prop="expiryDate" label="到期时间"> </el-table-column>
      <el-table-column fixed="right" label="操作" width="100">
        <template slot-scope="scope">
          <el-button type="text" size="small" @click="handleDetail(scope.row)"
            >详情</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页器 -->
    <el-pagination
      class="mgt-20"
      background
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="page"
      :page-sizes="[5, 20, 30, 40, 50]"
      :page-size="pageSize"
      layout=" prev, pager, next"
      :total="total"
    >
    </el-pagination>
    <!-- 充值弹框 -->
    <el-dialog
      title="充值"
      :visible.sync="dialogVisible"
      width="30%"
      center
      top="30vh"
      :close-on-click-modal="false"
    >
      <el-form
        v-if="!isPay"
        :rules="rules"
        ref="topForm"
        :model="topForm"
        label-width="80px"
      >
        <el-form-item label="SIM卡号">
          <el-input :disabled="true" v-model="topForm.sim"></el-input>
        </el-form-item>
        <el-form-item label="充值套餐" prop="menu">
          <el-select
            @change="changeMenu"
            v-model="topForm.menu"
            placeholder="请选择充值套餐"
          >
            <el-option
              v-for="(v, i) in menuArr"
              :key="i"
              :label="v.packageName"
              :value="v.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="扫码支付" v-if="topForm.menu">
          <el-image
            style="width: 200px; height: 200px"
            :src="topForm.img"
            :preview-src-list="topForm.imgList"
          >
          </el-image>
        </el-form-item>
        <div
          v-if="topForm.menu"
          class="center"
          style="color: red;font-weight: 600;"
        >
          付款成功后请勿立即退出支付页面！
        </div>
      </el-form>
      <div v-else class="center f30 color0063ea">
        支付成功！
      </div>
    </el-dialog>
  </div>
</template>

<script>
import breadcrumbs from "@/components/breadcrumbs.vue";
import btns from "@/components/btns.vue";
import { handleConfirm, handleAlert } from "../../components/UtilsIf";
import store from "../../store";

export default {
  components: {
    breadcrumbs,
    btns,
  },
  data() {
    return {
      pickerOptionsEnd: {
        disabledDate: (time) => {
          let beginDateVal = this.form.startTime;
          if (beginDateVal) {
            return (
              time.setHours(0, 0, 0, 0) <
              new Date(beginDateVal).setHours(0, 0, 0, 0)
            );
          } else {
            return time.getTime() < Date.now() - 8.64e7;
          }
        },
      },
      form: {},
      tableData: [],
      // 分页数据
      page: 1, // 当前页，默认
      pageSize: 20, //每页显示多少条数据，默认
      total: 50, // 数据总条数
      multipleSelection: [],
      dialogVisible: false,
      topForm: {},
      rules: {
        menu: [{ required: true, message: "请选择充值套餐", trigger: "blur" }],
      },
      companyId: null,
      menuArr: [],
      isPay: false,
      timer: null,
    };
  },
  created() {
    this.getROLE();
    this.getList();
  },
  beforeDestroy() {
    clearInterval(this.timer); //结束定时器，
  },

  watch: {
    "form.startTime"() {
      if (this.form.startTime == null) {
        this.form.endTime = null;
      }
    },
  },
  methods: {
    // 导出
    export() {
      handleConfirm("确认导出吗?", "info")
        .then(() => {
          this.$api.sim.simExport({ companyId: this.companyId }).then((res) => {
            handleAlert("导出成功", "success");
            this.exportVisible = false;
            const link = document.createElement("a");
            link.style.display = "none";
            link.href = URL.createObjectURL(res);
            link.setAttribute("download", "物联网卡列表.xls");
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
          });
        })
        .catch(() => {
          return;
        });
    },
    // 拉出支付码
    changeMenu(e) {
      this.$api.sim
        .payCode({ iccid: this.topForm.sim, packageId: e, payType: 2 })
        .then((res) => {
          if (res.code === 200) {
            this.topForm.img = res.data.img;
            this.topForm.imgList = [res.data.img];
            this.getPayTrun(res.data.orderNo);
            this.timer = setInterval(() => {
              this.getPayTrun(res.data.orderNo);
            }, 1000);
          }
        });
    },
    getPayTrun(n) {
      this.$api.sim.payTrun({ orderNo: n }).then((res) => {
        if (res.code === 200) {
          if (res.data == true) {
            this.isPay = true;
            clearInterval(this.timer);
          }
        }
      });
    },
    // 充值按钮
    top() {
      if (this.multipleSelection.length !== 1) {
        handleAlert("请选择一条数据", "error");
        return;
      }
      this.$api.sim.menuPull({ packageStatus: 1 }).then((res) => {
        if (res.code === 200) {
          this.menuArr = res.data;
          this.topForm = {
            sim: this.multipleSelection[0].iccid,
            menu: "",
            img: "",
          };
          this.isPay = false;
          this.dialogVisible = true;
        }
      });
    },
    // 进入详情
    handleDetail(row) {
      this.$router.push({
        path: "/SIM/SIMList/SIMDetail",
        query: {
          iccid: row.iccid,
        },
      });
    },
    getROLE() {
      var token = store.getters.get_token;
      if (token) {
        this.companyId = token.companyId;
      }
    },
    getList(pageNum) {
      if (!pageNum) {
        this.page = 1;
      }
      this.$api.sim
        .simChuList({
          pageNum: this.page,
          pageSize: this.pageSize,
          carrier: this.form.operator,
          cartStatus: this.form.status,
          companyId: this.companyId,
          endTime: this.form.endTime,
          equipmentNum: this.form.equipmentNum,
          iccid: this.form.simNum,
          netStatus: this.form.networkStatus,
          source: this.form.channel,
          startTime: this.form.startTime,
        })
        .then((res) => {
          if (res.code == 200) {
            this.tableData = res.data.rows;
            this.total = res.data.total;
          }
        });
    },
    exec(fun) {
      if (this[fun]) {
        this.funTit = fun;
        this[fun]();
      } else {
        this.$message.error("方法未定义");
      }
    },
    //表格序号，根据索引+1
    indexMethod(index) {
      return index + 1;
    },
    // 分页事件
    // 每页显示多少条,条数改变时触发事件
    handleSizeChange(val) {
      this.pageSize = val;
      this.getList(this.page);
    },
    // 当前页面,当前页面改变时触发事件
    handleCurrentChange(val) {
      this.page = val;
      this.getList(this.page);
    },
    // 表格多选发生改变时
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
  },
};
</script>

<style lang="scss" scoped></style>
